import React from 'react';
import { ScreenRedirect } from '@atlassian/jira-screen-redirect/src/ui/ScreenRedirect.tsx';
import { useRouter } from '@atlassian/react-resource-router';
import ErrorPagesNotFound from '@atlassian/jira-router-routes-common/src/ui/error-pages/not-found/index.tsx';

export const RedirectToListOnlyPage = () => {
	const [{ match }] = useRouter();

	const projectKey = match?.params?.projectKey;
	if (!projectKey) {
		return <ErrorPagesNotFound />;
	}
	const redirectPath = `/jira/servicedesk/projects/${projectKey}/settings/playbooks/list`;

	return <ScreenRedirect to={redirectPath} />;
};
